"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Switch = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Switch = styled_components_1.default.span.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['sizeOption'].includes(prop);
  }
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  border-radius: 1.375rem;\n\n  &::before,\n  ::after {\n    content: '';\n    display: block;\n    top: -0.25rem;\n    left: -0.25rem;\n    border-radius: inherit;\n  }\n\n  &::before {\n    width: ", ";\n    height: ", ";\n    border-radius: 1.375rem;\n    background-color: ", ";\n  }\n\n  &::after {\n    transition: ", ";\n    position: absolute;\n    top: 50%;\n    left: 8%;\n    transform: translate(0, -50%);\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    box-shadow: 0 0.0625rem 0.0625rem rgba(44, 50, 66, 0.08);\n    background: ", ";\n  }\n"], ["\n  position: relative;\n  border-radius: 1.375rem;\n\n  &::before,\n  ::after {\n    content: '';\n    display: block;\n    top: -0.25rem;\n    left: -0.25rem;\n    border-radius: inherit;\n  }\n\n  &::before {\n    width: ", ";\n    height: ", ";\n    border-radius: 1.375rem;\n    background-color: ", ";\n  }\n\n  &::after {\n    transition: ", ";\n    position: absolute;\n    top: 50%;\n    left: 8%;\n    transform: translate(0, -50%);\n    width: ", ";\n    height: ", ";\n    border-radius: 50%;\n    box-shadow: 0 0.0625rem 0.0625rem rgba(44, 50, 66, 0.08);\n    background: ", ";\n  }\n"])), function (_a) {
  var sizeOption = _a.sizeOption;
  return sizeOption === 'small' ? '2rem' : '2.875rem';
}, function (_a) {
  var sizeOption = _a.sizeOption;
  return sizeOption === 'small' ? '1rem' : '1.5rem';
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["400"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('MOTION.DEFAULT_TRANSITION', theme);
}, function (_a) {
  var sizeOption = _a.sizeOption;
  return sizeOption === 'small' ? '0.625rem' : '1rem';
}, function (_a) {
  var sizeOption = _a.sizeOption;
  return sizeOption === 'small' ? '0.625rem' : '1rem';
}, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY.WHITE', theme);
});
var templateObject_1;